// Vue/i18n 与 Sentry 尚未加载时使用的入口文案，仍按部署语言选择。
export const unsupportedBrowserMessages = {
  zh: { title: '请更新浏览器', hint: '当前浏览器版本过旧，请更新后重新打开无心云志。' },
  en: { title: 'Please update your browser', hint: 'Your browser is too old to run Slow Vale. Update it, then open this page again.' },
}
